'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faTimesCircle = require('@fortawesome/fontawesome-free-regular/faTimesCircle');
var _faTimesCircle2 = _interopRequireDefault(_faTimesCircle);
var _NutritionFacts = require('../nutrition/NutritionFacts');
var _NutritionFacts2 = _interopRequireDefault(_NutritionFacts);
var _BazaarVoice = require('../bazaarvoice/BazaarVoice');
var _BazaarVoice2 = _interopRequireDefault(_BazaarVoice);
var _Social = require('../social/Social');
var _Social2 = _interopRequireDefault(_Social);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ProductCard = function ProductCard(props) {
  var productSocial = props.product.social;
  return _react2.default.createElement('div', {
    className: 'product-card ' + props.className + ' ' + (props.active ? 'is-active' : '')
  }, _react2.default.createElement('div', {
    className: 'product-card__inner'
  }, props.active ? _react2.default.createElement('button', {
    className: 'product-card__close btn btn--close',
    onClick: props.onCloseClick,
    type: 'button',
    'aria-label': 'Close'
  }, _react2.default.createElement(_reactFontawesome2.default, {
    icon: _faTimesCircle2.default
  })) : null, _react2.default.createElement('h1', {
    className: 'product-card__name'
  }, props.product.name), props.socialEnabled && props.active ? _react2.default.createElement(_Social2.default, _extends({
    className: 'product-card__social',
    emailSubject: productSocial.email.subject,
    emailMessage: productSocial.email.message,
    facebookImage: productSocial.facebook.image,
    facebookSubject: productSocial.facebook.subject,
    facebookMessage: productSocial.facebook.message,
    pinterestImage: productSocial.pinterest.image,
    pinterestMessage: productSocial.pinterest.message,
    twitterMessage: productSocial.twitter.message
  }, props.social)) : null, props.bazaarVoiceEnabled && props.active ? _react2.default.createElement(_BazaarVoice2.default, {
    brand: props.product.brand_code,
    slug: props.product.slug,
    active: props.active
  }) : null, props.product.description ? _react2.default.createElement('p', {
    className: 'product__description'
  }, props.product.description) : null, _react2.default.createElement(_NutritionFacts2.default, _extends({
    product: props.product
  }, props.nutritionFacts))));
};
ProductCard.defaultProps = {
  active: false,
  bazaarVoiceEnabled: true,
  className: '',
  nutritionFacts: {},
  onCloseClick: function onCloseClick() {
    return false;
  },
  social: {},
  socialEnabled: true
};
ProductCard.propTypes = {
  active: _propTypes2.default.bool,
  bazaarVoiceEnabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  nutritionFacts: _propTypes2.default.shape({
    calorieSource: _propTypes2.default.string,
    dailyValue: _propTypes2.default.string,
    disclaimer: _propTypes2.default.string,
    factPunctuation: _propTypes2.default.string,
    ingredientsTitle: _propTypes2.default.string,
    perServing: _propTypes2.default.string,
    servingSize: _propTypes2.default.string,
    threeColumn: _propTypes2.default.bool
  }),
  onCloseClick: _propTypes2.default.func,
  product: _propTypes2.default.shape({
    brand_code: _propTypes2.default.string,
    description: _propTypes2.default.string,
    ingredient: _propTypes2.default.array,
    name: _propTypes2.default.string,
    nutrition: _propTypes2.default.shape({}),
    product_info: _propTypes2.default.shape({
      serving_size: _propTypes2.default.string,
      serving_units_code: _propTypes2.default.string
    }),
    slug: _propTypes2.default.string,
    social: _propTypes2.default.shape({
      email: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        message: _propTypes2.default.string
      }),
      facebook: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      pinterest: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      twitter: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string
      })
    })
  }).isRequired,
  social: _propTypes2.default.shape({
    emailSubject: _propTypes2.default.string,
    emailMessage: _propTypes2.default.string,
    emailUrl: _propTypes2.default.string,
    facebookAppId: _propTypes2.default.string,
    facebookIcon: _propTypes2.default.oneOf(['default', 'square']),
    facebookImage: _propTypes2.default.string,
    facebookMessage: _propTypes2.default.string,
    facebookSubject: _propTypes2.default.string,
    facebookUrl: _propTypes2.default.string,
    pinterestIcon: _propTypes2.default.oneOf(['default', 'p', 'square']),
    pinterestImage: _propTypes2.default.string,
    pinterestMessage: _propTypes2.default.string,
    pinterestUrl: _propTypes2.default.string,
    twitterIcon: _propTypes2.default.oneOf(['default', 'square']),
    twitterMessage: _propTypes2.default.string,
    twitterUrl: _propTypes2.default.string,
    services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'facebook', 'pinterest', 'print', 'twitter']))
  }),
  socialEnabled: _propTypes2.default.bool
};
exports.default = ProductCard;